var map = {
	"./businessclass/desktop_en.webp": [
		32062,
		32062
	],
	"./businessclass/mobile_en.webp": [
		871032,
		71032
	],
	"./businessclass/tablet_en.webp": [
		78190,
		78190
	],
	"./radissonhotels/desktop_en.webp": [
		65560,
		65560
	],
	"./radissonhotels/mobile_en.webp": [
		680093,
		2474
	],
	"./radissonhotels/tablet_en.webp": [
		813036,
		13036
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 723647;
module.exports = webpackAsyncContext;